/**
 * Safari 16 supports AbortController but lacks AbortSignal.any. Install before
 * application code so dependencies (including Trigger's chat SDK) use it too.
 */
export function installAbortSignalAny(): void {
  if (typeof AbortSignal === 'undefined' || typeof AbortSignal.any === 'function') {
    return
  }

  Object.defineProperty(AbortSignal, 'any', {
    configurable: true,
    writable: true,
    value(signals: AbortSignal[]): AbortSignal {
      const sources = [...new Set(signals)]
      const controller = new AbortController()
      const alreadyAborted = sources.find((signal) => signal.aborted)
      if (alreadyAborted) {
        controller.abort(alreadyAborted.reason)
        return controller.signal
      }

      const subscriptions = sources.map((signal) => {
        const onAbort = () => {
          // Remove subscriptions before dispatching, including when a consumer
          // synchronously aborts another source in its own abort handler.
          for (const subscription of subscriptions) {
            subscription.signal.removeEventListener('abort', subscription.onAbort)
          }
          controller.abort(signal.reason)
        }
        return { signal, onAbort }
      })
      for (const { signal, onAbort } of subscriptions) {
        signal.addEventListener('abort', onAbort, { once: true })
      }
      return controller.signal
    },
  })
}
